import { Navigate } from 'react-router-dom';

import useAuth from '@hooks/useAuth';

import LoginForm from '@components/auth/LoginForm';

export default function Login() {
  // ==========================================================================
  // General
  // ==========================================================================
  const { isAuthenticated } = useAuth();

  // ==========================================================================
  // State
  // ==========================================================================

  // ==========================================================================
  // Api
  // ==========================================================================

  // ==========================================================================
  // Form
  // ==========================================================================

  // ==========================================================================
  // Handlers
  // ==========================================================================

  // ==========================================================================
  // Render
  // ==========================================================================
  return isAuthenticated ? <Navigate to="/" replace /> : <LoginForm />;
}
